import styled, { css } from 'styled-components';
import { baseStyling } from '@redsift/design-system';
import { StyledToastProps } from './types';

/**
 * Component style.
 */
export const StyledToast = styled.div<StyledToastProps>`
  ${baseStyling}

  color: var(--redsift-color-neutral-x-dark-grey);

  padding: 16px;
  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px rgb(0 0 0 / 14%), 0px 1px 10px rgb(0 0 0 / 12%);

  ${({ $hasTitle, $variant }) => css`
    background-color: ${$variant === 'loading'
      ? 'var(--redsift-color-neutral-white)'
      : `var(--redsift-color-notifications-${$variant}-hover)`};

    .redsift-toast-header__icon-button {
      background-color: transparent;
      padding: 0px;
      .redsift-icon {
        color: var(--redsift-color-neutral-x-dark-grey);
      }

      &:hover,
      &:focus-visible {
        background-color: var(--redsift-color-notifications-${$variant}-active);

        .redsift-icon {
          color: var(--redsift-color-neutral-x-dark-grey);
        }
      }
    }

    .redsift-toast__content {
      margin-top: ${$hasTitle ? '8px' : '-24px'};
      margin-left: 38px;
    }
  `}
`;
